// import axios from 'axios';

// // Set language in localStorage (persistent across sessions)
// export const setLanguage = (lang) => {
//   localStorage.setItem('language', lang);
// };

// // Get the current language from localStorage (defaults to 'DE')
// export const getCurrentLanguage = () => {
//   return localStorage.getItem('language') || 'DE'; // Default to German if no language is set
// };

// // Translation function to fetch translation based on the ID and current language
// export const translate = async (translateID) => {
//   const currentLanguage = getCurrentLanguage(); // Use the stored language
//   try {
//     const response = await axios.get(`/api/translate/${translateID}`);
//     const translation = response.data;

//     // Return the translation for the current language
//     if (currentLanguage === 'DE') {
//       return translation.DE || ''; // Fallback to empty string if no translation is found
//     } else if (currentLanguage === 'EN') {
//       return translation.EN || '';
//     } else if (currentLanguage === 'FR') {
//       return translation.FR || '';
//     }
//   } catch (error) {
//     console.error('Error fetching translation:', error);
//     return ''; // Fallback to empty string in case of an error
//   }
// };
import axios from 'axios';

// Set language in localStorage (persistent across sessions)
export const setLanguage = (lang) => {
  localStorage.setItem('language', lang);
};

// Get the current language from localStorage (defaults to 'DE')
export const getCurrentLanguage = () => {
  return localStorage.getItem('language') || 'DE';
};

// Alle Übersetzungen werden beim ersten Aufruf einmal geladen – ein Request statt einem pro Text
// (vorher bis zu 69 Einzelabrufe pro Seite). Gleichzeitige Aufrufe teilen sich denselben Request.
let allTranslations = null;
const loadAllTranslations = () => {
  if (!allTranslations) {
    allTranslations = axios
      .get('/api/translate/all')
      .then((response) => response.data)
      .catch((error) => {
        console.error('Error fetching translations:', error);
        allTranslations = null; // beim nächsten Aufruf erneut versuchen
        return null;
      });
  }
  return allTranslations;
};

// Translation function: Text zur ID in der aktuellen Sprache
export const translate = async (translateID) => {
  const currentLanguage = getCurrentLanguage();
  const translations = await loadAllTranslations();

  if (translations) {
    return (translations[translateID] && translations[translateID][currentLanguage]) || '';
  }

  // Fallback: einzelne Übersetzung laden
  try {
    const response = await axios.get(`/api/translate/${translateID}`);
    return response.data[currentLanguage] || '';
  } catch (error) {
    console.error('Error fetching translation:', error);
    return ''; // Fallback auf leeren String im Fehlerfall
  }
};
